import { axiosInstance } from "@/config/axiosInstance";

// ? Change Status of Leave Application Action
export const takeActionOnLeaveApplicationAsApprover =
  (approverKey: string) => (data: { status: string; leaveId: string }) =>
    axiosInstance
      .post(
        `/leave/approver/action/${data.leaveId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${approverKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Change Status of Allowance Request Action
export const takeActionOnAllowanceRequestAsApprover =
  (approverKey: string) => (data: { status: string; allowanceId: string }) =>
    axiosInstance
      .post(
        `/allowance/approver/action/${data.allowanceId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${approverKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
